import React, { useEffect, useState } from "react";
import { Drawer, DrawerContent } from "@/components/ui/drawer"; // adjust import to your project
import { Dialog, DialogContent } from "@/components/ui/dialog"; // adjust import to your project
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import ModalCustomWishlistLimit from "@/components/ModalCustomWishlistLimit"; // adjust path
import { useIsMobile } from "@/hooks/useIsMobile";

// ✅ Extracted component to avoid remount issues
const FormContent = ({
  name,
  setName,
  nameExists,
  handleSubmit,
  handleClose,
}) => (
  <>
    <div>
      <p className='text-lg font-semibold'>Add Directory</p>
      <p className='mt-1 text-sm leading-snug opacity-60'>
        {`Add a name to your directory so you can identify it. Click save when
        you're done.`}
      </p>
    </div>
    <div className='grid gap-4 py-4'>
      <Input
        onChange={(e) => setName(e.target.value)}
        className='flex-1 bg-white rounded-lg shadow-sm text-background border-background/20 focus-visible:ring-0'
        value={name}
      />
      {nameExists && (
        <small className='text-red-500'>
          The name already exists in your directory; please choose a different
          one.
        </small>
      )}
    </div>
    <div className='flex justify-end gap-2'>
      <Button
        onClick={handleClose}
        variant='outline'
        className='hidden w-full bg-white rounded-lg lg:flex lg:w-auto lg:mt-0 border-black/20 hover:bg-gray-50'
      >
        Cancel
      </Button>
      <Button
        type='submit'
        variant='secondary'
        onClick={handleSubmit}
        className='w-full rounded-lg lg:w-auto'
      >
        Save changes
      </Button>
    </div>
  </>
);

const WishlistAddNew = ({
  isOpen,
  setIsOpen,
  addWishlistCategory,
  wishlistCategories,
  id,
  type,
  hasSubscription,
  content_type_name,
}) => {
  const isMobile = useIsMobile();
  const handleClose = () => setIsOpen(false);
  const [name, setName] = useState("");
  const [nameExists, setNameExists] = useState(false);

  const handleSubmit = () => {
    const exists =
      wishlistCategories?.some(
        (cat) => cat.name.toLowerCase() === name.toLowerCase()
      ) || name.toLowerCase() === "my wishlist";

    if (exists) {
      return setNameExists(true);
    }

    addWishlistCategory({ name, id, type, content_type_name });
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      setName("");
      setNameExists(false);
    }
  }, [isOpen]);

  if (!hasSubscription) {
    return (
      <ModalCustomWishlistLimit
        isModalOpen={isOpen}
        setIsModalOpen={setIsOpen}
      />
    );
  }

  const formProps = {
    name,
    setName,
    nameExists,
    handleSubmit,
    handleClose,
  };

  return isMobile ? (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <DrawerContent className='p-5 pt-0 bg-white text-background rounded-t-3xl'>
        <div className='pt-3'>
          <FormContent {...formProps} />
        </div>
      </DrawerContent>
    </Drawer>
  ) : (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        className='sm:max-w-[425px] bg-white text-background !rounded-2xl p-5 gap-0'
        hideCloseButton
      >
        <FormContent {...formProps} />
      </DialogContent>
    </Dialog>
  );
};

export default WishlistAddNew;
